import { render, staticRenderFns } from "./ModalWarn.vue?vue&type=template&id=16197ef4&scoped=true"
import script from "./ModalWarn.vue?vue&type=script&lang=js"
export * from "./ModalWarn.vue?vue&type=script&lang=js"
import style0 from "./ModalWarn.vue?vue&type=style&index=0&id=16197ef4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16197ef4",
  null
  
)

export default component.exports